import React, { lazy, Suspense, useEffect, useState } from 'react';
import { Autocomplete, Box, Button, Stack, TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { getAllUsersNew } from '../../../../redux/features/generalSlice';
import { clearUserBasedKraSkillWill, getAllAssignedKra } from '../../../../redux/features/appraisalSlice';
import ToolTip from '../../../../components/ToolTip/ToolTip';
import GlobalDatagrid from '../../../../components/mui/DataGrid/GlobalDatagrid';
// import TagUserlibrary from '../../adminOperations/userSpecific/Kra/TagKraUser';
import DeleteAssignedKra from '../../adminOperations/userSpecific/Kra/DeleteAssignedLibrary';
import CustomSuspense from '../../../../components/Loader/CustomSuspense';
const TagUserlibrary = lazy(() => import('../../adminOperations/userSpecific/Kra/TagKraUser'));
const SkillAllView = () => {
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { alltaggedkra, loading } = useSelector((state) => state.appraisal);
  const { allUsers } = useSelector((state) => state.general);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const [selectedUsers, setSelectedUsers] = useState(undefined);
 const [showTagModal, setShowTagModal] = useState(false);
  const [value, setValue] = useState(dayjs());

  const data = {
    type: 'skills',
    userID: selectedUsers?.userID || '',
    limit: gridSize,
    page: pageNum,
    search: search,
  };

  useEffect(() => {
    if (allUsers.length === 0) {
      dispatch(getAllUsersNew());
    }
  }, []);

  useEffect(() => {
    if (pageNum && selectedUsers?.userID) {
      dispatch(getAllAssignedKra(data));
      return () => {
        dispatch(clearUserBasedKraSkillWill());
      };
    }
  }, [pageNum, gridSize, selectedUsers, search]);

  const Skill_Table_Head = [
    {
      field: 'sl_no',
      headerName: 'Sl No',
    },
    {
      field: 'userName',
      headerName: 'Employee',
      width: 250,
    },
    {
      field: 'libraryName',
      headerName: 'Skill',
      width: 250,
      renderCell: (params) => {
        return <ToolTip expand={params.row.libraryName} content={params.row.libraryName} />;
      },
    },
    {
      field: 'appraisal_weightage',
      headerName: 'Weightage (%)',
      width: 200,
    },
    {
      field: 'delete',
      headerName: 'Action',
      width: 150,
      renderCell: (params) => {
        return <DeleteAssignedKra id={params.row.appraisal_assignment_id} data={data} />;
      },
    },
  ];

  const handleusertype = (event, newValue) => {
    setSelectedUsers(newValue);
  };

  return (
    <Box sx={{ width: '100%', padding: 0 }}>
      <Box
        sx={{
          p: 2,
          display: 'flex',
          alignItems: { xs: 'flex-start', sm: 'center' },
          justifyContent: 'space-between',
          flexDirection: { xs: 'column', sm: 'row' },
        }}
      >
        <Autocomplete
          sx={{
            width: {
              xs: '100%',
              sm: '40%',
            },
            mb: 1,
          }}
          size="medium"
          name="Employees"
          options={allUsers}
          value={selectedUsers}
          onChange={handleusertype}
          getOptionLabel={(option) => option.name ?? ''}
          isOptionEqualToValue={(option, value) => option.userID === value.userID}
          renderInput={(params) => <TextField disabled fullWidth autoComplete="off" {...params} label="Employee" />}
        />
        <Box>{/* <TagUserlibrary dispatchData={data} library={"skills"} /> */}</Box>
        <Button variant="contained" onClick={() => setShowTagModal(true)} sx={{ boxShadow: 'none' }}>
          Tag Skill
        </Button>
      </Box>
      <GlobalDatagrid
        tableHead={Skill_Table_Head}
        rows={alltaggedkra?.data}
        meta={alltaggedkra?.meta?.totalRecords || 0}
        loading={loading}
        rowUniqueId="sl_no"
        rowClick={false}
      />

      <Suspense fallback={<CustomSuspense text="Loading Skill Module..." />}>
              {showTagModal && (
                <TagUserlibrary
                  externalOpen={showTagModal}
                  externalSetOpen={setShowTagModal}
                  dispatchData={data}
                  library="skills"
                />
              )}
            </Suspense>
    </Box>
  );
};

export default SkillAllView;
